import React from 'react';

const Modal = ({ isOpen, onClose, content }) => {
    if (!isOpen) return null; // Do not render if modal is closed
    
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-btn" onClick={onClose}>X</button>
                <div className="modal-body">
                    <h2>{content.title}</h2>
                    <p>{content.body}</p>
                </div>
            </div>
        </div>
    );
};

export default Modal;